import clsx from "clsx";
import { LandingButterLink } from "./LandingButterLink";

export const LandingCtas = ({ ctas }) => {
  if (!ctas) return null;
  return (
    <div className="LandingCtas">
      {ctas?.map(cta => (
        <LandingButterLink
          className={clsx(
            "LandingCtas-button",
            cta?.button_variant && `LandingCtas-button-${cta?.button_variant}`,
          )}
          variant={cta?.button_variant}
          demystIcon={cta?.show_button_logo === true}
          url={cta?.button_url}
          section={cta?.section}
          size={cta?.button_size}
          onClick={cta?.onClick}
          key={cta}
          mainCTA={cta?.mainCTA}
        >
          {cta?.button_label}
        </LandingButterLink>
      ))}
    </div>
  );
};
